<template>
    <section class="page7">
        <div class="contentSplit">
            <div class="text-left col1Split">
                <div>
                    <div class="flex-row" data-aos="zoom-in-up">
                        <p class="num-big text-yellow">#1</p>
                        <p class="text-bold text-big">Políticas e processos</p>
                    </div>
                    <div>
                        <p class="p1" data-aos="fade" data-aos-delay="500">
                            É preciso elaborar ou revisar as políticas internas
                            e os processos de controle de segurança da
                            informação.
                        </p>
                    </div>
                </div>
                <div class="p4">
                    <div
                        class="flex-row"
                        data-aos="zoom-in-up"
                        data-aos-delay="1000"
                    >
                        <p class="num-big text-yellow">#2</p>
                        <p class="text-bold text-big">Permissões de acesso</p>
                    </div>
                    <div>
                        <p class="p1" data-aos="fade" data-aos-delay="1500">
                            É fundamental definir quais áreas poderão ter acesso
                            às informações de candidatos, colaboradores e
                            terceiros, bem como a forma de utilização desses
                            <span class="text-bold">dados</span>.
                        </p>
                    </div>
                </div>
            </div>
            <div class="col2">
                <!-- <img src="~@/assets/img/page6-img.png" alt=""> -->
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.page7 {
    position: relative;
    background-image: url("~@/assets/img/page6-bg.png");
    background-size: cover;
    background-repeat: no-repeat;

    .contentSplit {
        display: flex;
        flex-direction: row;
        max-width: 1920px;
        margin: 0 auto;
    }
    .col1Split {
        order: 2;
        flex-basis: 500px;
        flex-shrink: 0;
        align-self: center;
        padding-right: 60px;
        max-width: 556px;
    }
    .col2 {
        float: none;
        height: 768px;
        min-width: 890px;
        background-image: url("~@/assets/img/page6-img.png");
        background-repeat: no-repeat;
        background-position: right;
        flex-shrink: 1;
    }
    .p4 {
        padding-bottom: 40px;
    }

    .flex-row {
        align-items: center;
    }
    .num-big {
        font-size: 2.3rem;
        font-weight: bold;
        padding-right: 20px;
    }

    @media (max-width: 1380px) {
        .col1Split {
            margin-right: 20px;
        }
        .col2 {
            min-width: 800px!important;
            width: 100%;
        }
    }
    @media (max-width: 900px) {
        .contentSplit {
            justify-content: center;
            padding: 0 20px 0 20px;
        }
        .col1Split {
            padding-right: 0;
            padding-top: 30px;
            max-width: 100%;
            flex-basis: 100%;
            flex-shrink: 0;
            margin: 0;
        }
        .col2 {
            display: none;
        }
    }
}
</style> 